import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { updateIdenMarket as updateIdenMarketAPI} from 'services/apiComparable';

const useUpdateIdenMarket = () => {
  const queryClient = useQueryClient();

  const{isPending: isEditing, isSuccess: isEdited, mutate: updateIdenMarket}=useMutation({
    mutationFn: updateIdenMarketAPI,
    onSuccess:(data)=>{
        queryClient.setQueryData(['updatedIdenmarket'],data)
        toast.success("Updated Successfully")
        queryClient.invalidateQueries({queryKey:['existingIdenMarketData']})
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })
  return{isEditing, isEdited, updateIdenMarket}
}

export default useUpdateIdenMarket